<div class='form-horizontal form-label-left'>
  <div class='row'>
    <div class='col-sm-5 col-md-5 col-xs-5'>
      <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.TITLE' | translate }}</span>
      <fieldset [disabled]='!editProfileRequestForm' class='fieldset-display'>
        <form [formGroup]='profileRequestForm' (ngSubmit)='onSubmitProfileRequest()' autocomplete='off' class='form-horizontal form-label-left'>
          <!-- REQUEST PROFILE TYPE -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.TYPE' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-12'>{{ profileRequest?.profileTypeReference | profileTypeLabel: profileTypes | noData }}</div>
          </div>

          <!-- REQUEST PROFILE CREATION DATE -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.CREATION_DATE' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-12'>{{ profileRequest?.creationDate | date: 'dd/MM/yyyy' | noData }}</div>
          </div>

          <!-- REQUEST PROFILE STATUS -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.STATUS' | translate }}</label>
            @if (user?.status) {
              <div class='col-sm-7 col-md-7 col-xs-12'><status-label type='REQUEST_PROFILE' [status]='profileRequest?.status'></status-label></div>
            }
            @if (!user?.status) {
              <div class='col-sm-7 col-md-7 col-xs-12'>-</div>
            }
          </div>

          <!-- REQUEST PROFILE REASON STATUS -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.REASON_STATUS' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-12'>
              <input type='text' id='reason' name='reason' class='form-control' formControlName='reasonStatus'/>
            </div>
          </div>

          <!-- REQUEST PROFILE RENEW -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.RENEW' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-12'>{{ profileRequest?.renewal | yesno | noData }}</div>
          </div>

          <!-- REQUEST PROFILE EXTERNAL REFERENCE -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.EXTERNAL_REFERENCE' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-12'>{{ profileRequest?.externalReference | noData }}</div>
          </div>

          <!-- REQUEST PROFILE REQUESTED START VALIDITY DATE -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.REQUESTED_START_VALIDITY_DATE' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-12'>{{ profileRequest?.requestedStartValidityDate | date: 'dd/MM/yyyy' | noData }}</div>
          </div>

          <!-- REQUEST PROFILE BEGIN VALIDITY DATE -->
          @if (profileRequest.status === ProfileRequestStatusEnum.VALIDATED) {
            <div class='form-group'>
              <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.BEGIN_VALIDITY_DATE' | translate }}</label>
              <div class='col-sm-7 col-md-7 col-xs-12'>{{ profileRequest?.beginValidityDate | date: 'dd/MM/yyyy' | noData }}</div>
            </div>
          }

          <!-- REQUEST PROFILE END VALIDITY DATE -->
          @if (profileRequest.status === ProfileRequestStatusEnum.VALIDATED) {
            <div class='form-group'>
              <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.END_VALIDITY_DATE' | translate }}</label>
              <div class='col-sm-7 col-md-7 col-xs-12'>{{ profileRequest?.endValidityDate | date: 'dd/MM/yyyy' | noData }}</div>
            </div>
          }

          <!-- REQUEST PROFILE COMMENT -->
          <div class='form-group'>
            <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_INFO.COMMENT' | translate }}</label>
            <div class='col-sm-7 col-md-7 col-xs-12'>
              <textarea class='form-control' rows='3' formControlName='comment'>{{ profileRequest?.comment | noData }}</textarea>
            </div>
          </div>

          <!-- ACTIONS BUTTONS -->
          @if (editProfileRequestForm) {
            <div class='form-group'>
              <app-smart-button buttonClasses='btn btn-success pull-right' buttonType='submit' onHttpCall='disable' showSpinner='true'>{{ 'ACTIONS.SEND' | translate }}</app-smart-button>
              <app-smart-button (click)='resetProfileRequestForm()' buttonClasses='btn btn-light pull-right' onHttpCall='disable' showSpinner='true'>{{ 'ACTIONS.CANCEL' | translate }}</app-smart-button>
            </div>
          }
        </form>
      </fieldset>
    </div>

    <div class='col-0-5'>
      @if (!editProfileRequestForm) {
        <app-edit-bloc-buttons (editEvent)="editProfileRequestForm = true;" [showDeleteB]='false'></app-edit-bloc-buttons>
      }
    </div>

    <div class='col-sm-6 col-md-6 col-xs-6'>
      <span class='section panel-role-title col-sm-12 col-md-12 col-xs-12' [ngClass]="{ 'user-view': userView }">{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.IDENTITY.TITLE' | translate }}</span>
      <!-- ACCOUNT ID -->
      <div class='form-group'>
        <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.IDENTITY.ID' | translate }}</label>
        <div class='col-sm-7 col-md-7 col-xs-12'>{{ user?.mobilityAccountId | noData }}</div>
      </div>

      <!-- ACCOUNT STATUS -->
      <div class='form-group'>
        <label class='col-sm-5 col-md-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.IDENTITY.STATUS' | translate }}</label>
        @if (user?.mobilityAccountIdentity?.mobilityAccountIdentityStatus) {
          <div class='col-sm-7 col-md-7 col-xs-12'><status-label [status]='user?.mobilityAccountIdentity?.mobilityAccountIdentityStatus'></status-label></div>
        }
        @if (!user?.mobilityAccountIdentity?.mobilityAccountIdentityStatus) {
          <div class='col-sm-7 col-md-7 col-xs-12'>-</div>
        }
      </div>

      <!-- CIVILITY -->
      <div class='form-group'>
        <label class='col-md-5 col-sm-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.IDENTITY.GENDER' | translate }}</label>
        @if (user?.mobilityAccountIdentity?.mobilityAccountTitle === 'M') {
          <div class='col-md-7 col-sm-7 col-xs-12'>Monsieur</div>
        }
        @if (user?.mobilityAccountIdentity?.mobilityAccountTitle === 'F') {
          <div class='col-md-7 col-sm-7 col-xs-12'>Madame</div>
        }
        @if (!user?.mobilityAccountIdentity?.mobilityAccountTitle) {
          <div class='col-md-7 col-sm-7 col-xs-12'>-</div>
        }
      </div>

      <!-- FIRSTNAME -->
      <div class='form-group'>
        <label class='col-md-5 col-sm-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.IDENTITY.FIRST_NAME' | translate }}</label>
        <div class='col-md-7 col-sm-7 col-xs-12'>{{ user?.mobilityAccountIdentity?.mobilityAccountFirstName | noData }}</div>
      </div>

      <!-- LASTNAME -->
      <div class='form-group'>
        <label class='col-md-5 col-sm-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.IDENTITY.LAST_NAME' | translate }}</label>
        <div class='col-md-7 col-sm-7 col-xs-12'>{{ user?.mobilityAccountIdentity?.mobilityAccountLastName | noData }}</div>
      </div>

      <!-- BIRTHDATE -->
      <div class='form-group'>
        <label class='col-md-5 col-sm-5 col-xs-12'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.IDENTITY.BIRTH_DATE' | translate }}</label>
        <div class='col-md-7 col-sm-7 col-xs-12'>{{ user?.mobilityAccountIdentity?.mobilityAccountBirthDate | date:'dd/MM/yyyy' | noData }}</div>
      </div>
    </div>
  </div>
</div>
<ap-profile-request-documentary-proofs [userView]='userView' [documentaryProofs]='profileRequest.documentaryProofs' [mobilityAccountId]='user.mobilityAccountId' [profileRequestStatus]='profileRequest.status' (openDialog)='openDialogTo($event)' (onChangeDocument)='updateEditValidateButton($event)'></ap-profile-request-documentary-proofs>
@if (profileRequest.status === ProfileRequestStatusEnum.AWAITING_VALIDATION) {
  <div class='row actions-section'>
    <div class='col-sm-12 col-md-12 col-xs-12'>
      @if (!editValidateButton) {
        <div class='pull-right' ap-tooltip="{{ 'SHARED.REQUEST_VALIDATION.TOOLTIP.DISABLED_VALIDATION_REQUEST' | translate }}" placement='top'>
          <button (click)='openDialogTo(true)' class='btn btn-success' [disabled]='editProfileRequestForm'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_ACTIONS.VALIDATE' | translate }}</button>
        </div>
      }
      @if (editValidateButton) {
        <button (click)='openDialogTo(true)' class='btn btn-success' [disabled]='editProfileRequestForm'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_ACTIONS.VALIDATE' | translate }}</button>
      }
      <button (click)='openDialogTo(false)' class='btn btn-danger pull-right' [disabled]='editProfileRequestForm'>{{ 'PROFILE.PROFILE_REQUEST_DETAIL.COMMON.REQUEST_ACTIONS.REFUSE' | translate }}</button>
    </div>
  </div>
}
